var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Jordan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M42.716,31H13.2l-6.164,3.556C10.567,40.219,16.834,44,24,44C32.579,44,39.875,38.588,42.716,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M25.333,24L13.2,31h29.516C43.532,28.818,44,26.467,44,24s-0.468-4.818-1.284-7H13.2L25.333,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M42.716,17C39.875,9.412,32.579,4,24,4c-7.166,0-13.433,3.781-16.964,9.444L13.2,17H42.716z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d50000",
    d: "M25.333,24L13.2,17l-6.164-3.556C5.123,16.51,4,20.12,4,24c0,3.88,1.123,7.49,3.036,10.556L13.2,31 L25.333,24z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11,21l0.668,1.734l1.738-0.547L12.5,23.805l1.5,1.055l-1.797,0.281L12.336,27L11,25.734L9.664,27 l0.133-1.859L8,24.859l1.5-1.055l-0.906-1.617l1.738,0.547L11,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Jordan);
export default __webpack_public_path__ + "static/media/icons8-jordan.4336fcf12b258361eed770a188790014.svg";
export { ForwardRef as ReactComponent };